// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BundleItems_wrapper__28oyw"};